var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M118.5 118.5H97.6V82.2c0-10.7-4.6-14-10.4-14-6.2 0-12.3 4.7-12.3 14.3v36H54V52.1h20.1v9.2h.3c2-4 9-11 19.8-11 11.7 0 24.3 6.8 24.3 27.1v41.1zM31 42.8c-6.7 0-12-5-12-12 0-6.9 5.3-12 12-12 6.6 0 12 5.1 12 12 0 7-5.4 12-12 12zm-10.5 75.6h21V52h-21v66.4zM128.8 0H10.3C4.6 0 0 4.6 0 10.3v118.5c0 5.6 4.6 10.2 10.3 10.2h118.5c5.6 0 10.2-4.6 10.2-10.2V10.3C139 4.6 134.4 0 128.8 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.394b6e3558ae07ec61acf961d784d622.svg";
export { ForwardRef as ReactComponent };